import { graphql } from 'react-relay';

export const gqlStudioListingMediaGroups = graphql`
  query studioListingMediaGroupsQuery($ids: [String!]!) {
    studioListingMediaGroups(ids: $ids) {
      ...studioListingMediaGroupFragment_full
    }
  }
`;
